import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFatherD.module.scss";

function PageFatherD() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p25", "png", s.description);
  const item01 = getImgSet("item__01__p25", "png", [s.item, s.item__01]);
  const notice = getImgSet("notice__p25", "png");
  const pointer = getImgSet("pointer__father", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__01", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        {imgA}
        <Link to="/father/e" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>{item01}</div>
      <div className={s.aside_right}>
        {description}
        <Link to="/father/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageFatherD);
